import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2">
            <span className="font-heading text-2xl font-bold text-primary-500 whitespace-nowrap">
              蜜桃网站
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1" aria-label="主导航">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-3 py-2 text-sm rounded-lg transition-colors whitespace-nowrap ${
                  location.pathname.includes(cat.slug)
                    ? 'text-primary-500 bg-primary-50'
                    : 'text-foreground-700 hover:text-primary-500 hover:bg-primary-50/50'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-3 py-2 text-sm rounded-lg transition-colors whitespace-nowrap ${
                location.pathname === '/about'
                  ? 'text-primary-500 bg-primary-50'
                  : 'text-foreground-700 hover:text-primary-500 hover:bg-primary-50/50'
              }`}
            >
              关于我们
            </Link>
          </nav>

          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700"
            aria-label="切换菜单"
          >
            <i className={`text-xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60">
          <nav className="flex flex-col px-4 py-3 gap-1" aria-label="移动端导航">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-3 text-sm rounded-lg transition-colors whitespace-nowrap ${
                  location.pathname.includes(cat.slug)
                    ? 'text-primary-500 bg-primary-50'
                    : 'text-foreground-700 hover:text-primary-500 hover:bg-primary-50/50'
                }`}
              >
                <i className={`${cat.icon} mr-2 w-4 h-4 inline-flex items-center justify-center`}></i>
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-3 text-sm rounded-lg transition-colors whitespace-nowrap ${
                location.pathname === '/about'
                  ? 'text-primary-500 bg-primary-50'
                  : 'text-foreground-700 hover:text-primary-500 hover:bg-primary-50/50'
              }`}
            >
              <i className="ri-information-line mr-2 w-4 h-4 inline-flex items-center justify-center"></i>
              关于我们
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}